var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgButtonContactUs(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a9a1ef02-825f-4654-ac7e-343b78b8f2cd",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 177 46",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .ab74d866-3dfc-4590-97f3-1df316ac7027{fill:#33aac6;}.bb79055d-d37f-4ca5-bf9a-718c7e6a7dd8{isolation:isolate;font-size:19px;fill:#fff;font-family:Rubik-Medium,\n            Rubik;font-weight:500;}\n        "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "af6f4bca-6a38-418d-b4e0-752c0cfb5b76",
    "data-name": "b4299354-cb40-4506-bb1e-a76d9a6c205d"
  }, /*#__PURE__*/React.createElement("g", {
    id: "eec94d1c-1ba7-4e91-af38-7d95984660e6",
    "data-name": "a42213f9-fe13-400c-871c-6176be44f835"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ed37e477-10ee-4519-9f3a-c0aac29fa2f4",
    "data-name": "b51c78e7-60b3-4273-8e8c-56864c4e9525"
  }, /*#__PURE__*/React.createElement("g", {
    id: "b5a60b5c-d577-40de-867a-7df3f8ff44cf",
    "data-name": "fdcce1da-05bb-4805-a031-33b415c6fc86"
  }, /*#__PURE__*/React.createElement("path", {
    className: "ab74d866-3dfc-4590-97f3-1df316ac7027",
    d: "M167,5a5,5,0,0,0-5-5H5A5,5,0,0,0,0,5V41a5,5,0,0,0,5,5H172a5,5,0,0,0,5-5Z"
  }))), /*#__PURE__*/React.createElement("text", {
    className: "bb79055d-d37f-4ca5-bf9a-718c7e6a7dd8",
    transform: "translate(23.46 30.38)"
  }, "CONTACT US")))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgButtonContactUs);
export default __webpack_public_path__ + "static/media/button-contact-us.20e5b858ba0f97d5ce4989635634c62d.svg";
export { ForwardRef as ReactComponent };